module.exports = require("./js/footable.js");
require("./css/footable.core.css");
require("./css/fonts/footable.eot");
require("./css/fonts/footable.svg");
require("./css/fonts/footable.ttf");
require("./css/fonts/footable.woff");


//////////////////
// WEBPACK FOOTER
// footable (bower component)
// module id = 1213
// module chunks = 1